module.exports = __webpack_public_path__ + "img/header-memoireRingsCheap.76534ab.jpg";